import { render, staticRenderFns } from "./TemplateListItem.vue?vue&type=template&id=4ebcad75&scoped=true"
import script from "./TemplateListItem.vue?vue&type=script&lang=ts"
export * from "./TemplateListItem.vue?vue&type=script&lang=ts"
import style0 from "./TemplateListItem.vue?vue&type=style&index=0&id=4ebcad75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebcad75",
  null
  
)

export default component.exports